import { useRouter }  from "next/router";
import React          from "react";
import useSWRInfinite from "swr/infinite";

import { fetchTabData, tabList } from "../utils";

import Presentation from "./presentation";

const UserProfileTabs = ( { userId, activeTab, activeTabData = [] } ) => {
	const router = useRouter ();

	const { data, error, size, setSize, mutate } = useSWRInfinite (
		index => {
			return { key: activeTabData.length ? "user-profile-feed-list" : null, pageNo: index + 2, id: userId, tab: activeTab };
		},
		fetchTabData
	);

	// state for infinite call logic
	let feedData               = [].concat.apply ( [], data );
	const isLoadingInitialData = !data && !error && activeTabData.length;
	const isEmpty              = data?.[size - 1]?.length === 0;
	const isLoadingMore        = isLoadingInitialData || ( size > 0 && data && typeof data[size - 1] === "undefined" );

	const onTabChange = val => {
		router.push ( `/profile/${ userId }/?tab=${ val }` );
	};

	const fetchMore =  () => {
		setSize ( size + 1 );
	};

	const updateDeletedPost = id => {
		mutate ( feedData.filter ( el => el.id !== id ) );
	};

	return (
		<Presentation
			activeTab         = { activeTab }
			fetchMore         = { fetchMore }
			isDepleted        = { isEmpty || !activeTabData.length }
			isLoading         = { isLoadingMore }
			list              = { [ ...activeTabData, ...feedData ] }
			onTabChange       = { onTabChange }
			tabList           = { tabList }
			updateDeletedPost = { updateDeletedPost }
		/>
	);
};

export default UserProfileTabs;